import { createSelector } from 'reselect';
import Immutable from 'immutable';
import { getSingularUGCByUsers } from './UGCBaseSelector';

const getTransactions = state => state.getIn(['ugc', 'privateNotesTransactions'], Immutable.Map());

export const getPrivateNotesByUsers = getSingularUGCByUsers('privateNotes');

export const getPrivateNotesTransactions = createSelector([getTransactions], (transactions) => transactions);

export default {
  getPrivateNotesByUsers,
  getPrivateNotesTransactions
};



// WEBPACK FOOTER //
// ./app/selectors/ugc/PrivateNotesSelector.js